import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createOrganisation } from '@api/organisations';

import { ESnackbarTypes } from '@enums/common';

import { ORGANISATIONS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateCreateOrganisation = (onSettledCallbacks?: Array<() => void>) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleCreateOrganisation,
		isLoading: isLoadingCreateOrganisation,
	} = useMutation({
		mutationKey: [ORGANISATIONS],
		mutationFn: createOrganisation,
		onSuccess: () => {
			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			dispatch(setSnackbar({
				message: responseMessages.createdOrganisation,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([ORGANISATIONS]);
		},
	});

	return {
		handleCreateOrganisation,
		isLoadingCreateOrganisation,
	};
};
